module.exports = __webpack_public_path__ + "img/logo_11st@3x.31f59232.png";